import React from 'react';
import { HeroSection } from '../components/dentafix/HeroSection';
import { PainMirrorSection } from '../components/dentafix/PainMirrorSection';
import { ProductRevealSection } from '../components/dentafix/ProductRevealSection';
import { HowItWorksSection } from '../components/dentafix/HowItWorksSection';
import { BenefitStackSection } from '../components/dentafix/BenefitStackSection';
import { LifestyleGallerySection } from '../components/dentafix/LifestyleGallerySection';
import { TestimonialsSection } from '../components/dentafix/TestimonialsSection';
import { ComparisonSection } from '../components/dentafix/ComparisonSection';
import { TrustBannerSection } from '../components/dentafix/TrustBannerSection';
import { BundleOfferSection } from '../components/dentafix/BundleOfferSection';
import { GuaranteeSection } from '../components/dentafix/GuaranteeSection';
import { FinalCloseSection } from '../components/dentafix/FinalCloseSection';
import { StickyCartBar } from '../components/dentafix/StickyCartBar';
import { LiveOrderPopup } from '../components/dentafix/LiveOrderPopup';
export function DentafixPage() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 antialiased overflow-x-hidden" data-id="element-355">
      <HeroSection data-id="element-356" />
      <PainMirrorSection data-id="element-357" />
      <ProductRevealSection data-id="element-358" />
      <HowItWorksSection data-id="element-359" />
      <BenefitStackSection data-id="element-360" />
      <LifestyleGallerySection data-id="element-361" />
      <TestimonialsSection data-id="element-362" />
      <ComparisonSection data-id="element-363" />
      <TrustBannerSection data-id="element-364" />
      <BundleOfferSection data-id="element-365" />
      <GuaranteeSection data-id="element-366" />
      <FinalCloseSection data-id="element-367" />

      <StickyCartBar data-id="element-368" />
      <LiveOrderPopup data-id="element-369" />
    </main>;
}